export default __webpack_public_path__ + "static/media/profile-cover.005ec103.jpg";